import styled from 'vue-styled-components';
import { GRAY, BLUE } from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@/styles/common.styled.component';

export const ComponentWrapper = styled.div``;

export const MainTitle = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const LeftWrapper = styled(FLEX_COLUMN_DIV)`
    font-size: 18px;
    font-weight: 500;
    color: ${GRAY(100)};
`;

export const MainTitleTop = styled(FLEX_VERTICAL_CENTER_DIV)`
    color: ${GRAY(100)};

    & svg {
        margin-left: 12px;
        fill: ${BLUE(60)};
    }
`;
